import React from 'react';
import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { embeddedIssuePreloadLayoutBuilder } from '@jira/platform__layouts-issue-preload-layout/src/index.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { softwareCapacityRoute } from '@jira/router-routes__software-capacity-routes/src/softwareCapacityRoute.tsx';
import { EntryPointCapacityWithHeaderSkeleton } from '@jira/platform__skeletons/src/ui/capacity/CapacitySkeleton.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import { capacityRouteEntry } from './common/capacityRouteEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareCapacityRouteEntry: Route = createEntry(softwareCapacityRoute, () => ({
	group: 'software',
	skeleton: () => <EntryPointCapacityWithHeaderSkeleton />,
	// eslint-disable-next-line no-restricted-syntax
	component: () => <EntryPointCapacityWithHeaderSkeleton />,

	entryPoint() {
		if (__SERVER__) {
			return undefined;
		}
		return capacityRouteEntry;
	},

	layout: composeLayouts(
		softwareProjectLayout,
		embeddedIssuePreloadLayoutBuilder([
			{
				query: ['selectedIssue'],
			},
		]),
	),

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: [
		...getNavigationResources(),
		...getIssueViewResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		projectThemeResource,
	],

	afterPaint: [LazyIssueApp],
	forPaint: [LazyAtlassianNavigation],
	ufoName: 'next-gen-capacity',
	supportsPreviewPanel: true,
	supportsProjectTheme: 'contoured',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
